var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid-view"},[_c('b-row',_vm._l((_vm.items),function(account){return _c('b-col',{key:account.id,attrs:{"lg":"3","md":"4"}},[_c('account-card',{attrs:{"account":account}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }